// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KeyFactors_wrapper__2jXqL","content":"KeyFactors_content__1cg1P"};